/* eslint-disable */
/*
 *
 * describe 定义各常量的值
 * @author mingchenxu
 * @date 2018/4/25 19:36
 * @param  * @param null
 * @return
 */

export default{
  install(Vue, options) {
    Vue.prototype.getData = function (constName) {
      return eval(constName)
    }
  }
}
// *********************************   定义各常量的值   ****************************** //
//                  初始化方法： 在组件中初始化时，定义变量接受全局VUE                 //
//                  方法中使用： this.别名.getData('常量名')                           //
// *********************************************************************************** //

/* ************************************ 病例各状态 start ****************************** */
// 退回病例
const STATE_0NN = -1
// 无效
const STATE_0LE = 0
// 切图生成中
const STATE_SLICING = 1
// 失败，异常
const STATE_FAIL = 2
// 未筛查
const STATE_0WS = 9
// 已预诊
const STATE_0BC = 10
// 初诊中
const STATE_1FG = 11
// 已初诊
const STATE_1FC = 12
// 复诊中
const STATE_2RG = 21
// 等待继续复诊
const STATE_2RN = 22
// 等待重新复诊
// const STATE_2RR = 23
// 等待下个医院复诊
const STATE_2RH = 26
// 已复诊
const STATE_2RA = 25
// 已复诊确认最终报告
// const STATE_2RC = 24
// 已初诊待会诊
const STATE_1FC_1GC = 30
// 已复诊待会诊
const STATE_2RC_1GC = 31
// 会诊中
const STATE_3GG = 32
// 诊断结束
const STATE_5DC = 50
// 最后一位复诊医生重新诊断中
const STATE_5RG = 51
// 诊断结束并打印报告
const STATE_6DC = 60
// 切图已删除
const STATE_PICTURE = 70
/* ************************************ 病例各状态 end ****************************** */

/* ************************************ 操作的URL地址 start ****************************** */

// 登陆url
const LOGIN_URL = 'login_login.do'
// 快速注册发送短信验证码URL
const FAST_REGISTER_CODE_URL = 'user/sendRegVerificationCode.do'
// 快速注册提交的URL
const FAST_REGISTER_SUBMIT_URL = 'user/fastRegisterUser.do'
// 短信找回密码发送验证码URL
const FORGET_PSW_SEND_CODE_URL = 'user/sendverificationcode.do'
// 找回密码确认修改URL
const FORGET_PSW_SUBMIT_URL = 'user/forgetPsw.do'
// 退出URL
const LOGIN_OUT_URL = 'loginout.do'
// 首页获取新闻轮播图
const NEWS_SWIPPER_URL = 'mobilenews/findlatest.do'
// 获取新闻详情
const NEWS_DETAIL_URL = 'mobilenews/newsDetail.do'
// 首页诊断数量获取URL
const INDEX_DIAGNOSE_NUM_URL = 'mobilecaseinfo/getindexdiagnum.do'
// 初诊列表URL
const FIRST_DIAGNOSE_LIST_URL = 'mobilecaseinfo/getdczcaselist.do'
// 复诊列表URL
const FURTHER_CONSULTATION_LIST_URL = 'mobilecaseinfo/getdfzcaselist.do'
// 会诊列表URL
const CONSULTATION_LIST_URL = 'mobilecaseinfo/getdhzcaselist.do'
// 医联体内病例列表URL
const MEDICAL_UNION_LIST_URL = 'mobilecaseinfo/getmeucaseList.do'
// 推送病例医生列表
const MEDICAL_UNION_DOC_LIST = 'mobilecaseinfo/getDocList.do'
// 指派病例给指定医生
const ADD_UNION_CASE_DOC = 'mobilecaseinfo/addCaseDoc.do'
// 已初诊列表URL
const ALREADY_FIRST_DIAGNOSED_LIST_URL = 'mobilecaseinfo/getyczcaselist.do'
// 已复诊列表URL
const ALREADY_FURTHER_CONSULTATION_LIST_URL = 'mobilecaseinfo/getyfzcaselist.do'
// 已会诊列表URL
const ALREADY_CONSULTATION_LIST_URL = 'mobilecaseinfo/getyhzcaselist.do'
// 退回病例URL
const INVALID_URL = 'caseinfo/invalid.do'
// 初诊URL
const STARTCZ_URL = 'caseinfo/mobilestartcz.do'
// 复诊URL
const STARTFZ_URL = 'caseinfo/mobilestartfz.do'
// 会诊URL
const STARTHZ_URL = 'caseinfo/mobilestarthz.do'
// 获取病例池报告截图配置信息URL
const CASE_POOL_CROP_INFO_URL = 'mobilecaseinfo/getcasediagnoseinfo.do'
// 更新截图信息
const UPDATE_CROP_INFO_URL = 'assign/updateCropInfo.do'
// 删除截图
const IS_DELETE_CROP = 'assign/isDelCrop.do'
// 获取病例玻片截图
const CASE_SAMPLE_CROP_URL = 'assign/getCurDoctorCropList.do'
// 上传截图URL
const UPLOAD_CROP_URL = 'assign/addCrop.do'
//  标记删除截图URL
const DELETE_CROP_URL = 'crop/deleteCrop.do'
// 取消诊断URL
const CANCEL_DIAGNOSE = 'caseinfo/mobilecanclediagnose.do'
// 重新诊断URL
const RESTART_DIAGNOSE = 'caseinfo/mobilerestartdiagnose.do'
// 获取病例诊断报告列表
const CASE_REPORT_LIST_URL = 'mobilereport/getCaseReportList.do'
// 查看诊断报告信息URL
const REPORT_DETAIL_URL = 'report/mobilegoreportdetail.do'
// 初诊 结束诊断URL
const CZCOMPLETE_URL = 'caseinfo/czcomplete.do'
// 复诊 结束诊断URL
const FZCOMPLETE_URL = 'caseinfo/fzcomplete.do'
// 获取会诊医生列表URL
const GET_GROUPDOCS_URL = 'caseinfo/mobilegetgroupdoc.do'
// 提交所选择的会诊医生列表URL
const SUBMIT_CHOSEN_GROUP_DOCS = 'caseinfo/mobilelaunchconsultation.do'
// 添加收藏病例URL
const ADD_CASE_COLLECTION = 'caseinfo/addcasecollection.do'
// 删除收藏病例URL
const DEL_CASE_COLLECTION = 'caseinfo/delcasecollection.do'
// 选中细胞截图URL
const CHOSEN_CELL_CROP_URL = 'assign/checkDoctorCrop.do'
// 选择组织截图URL
const CHOSEN_TISSUE_CROP_URL = 'assign/checkCrop.do'
// 去诊断报告编辑页面
const GO_DIAG_REPORT = 'mobilecaseinfo/godiagreport.do'
// 移动端查询选中词条的关联词条
const GET_ASS_KNOWLEDGE = 'report/mobileGetAssKnowledge.do'
// 沿用报告，去诊断报告编辑页面
const COPY_REPORT = 'mobilecaseinfo/copyreport.do'
// 采纳报告，获得页面数据
const ADOPT_REPORT = 'report/mobileadoptreport.do'
// 报告结果编辑页面完成诊断出报告
const FINISH_DIAGNOSE = 'mobilereport/finishdiagnose.do'
// 获取用户信息URL
const PERSONINFO_URL= 'mobileuser/getUserInfo.do'
// 修改用户信息URL
const UPDATEPERSONINFO_URL= 'mobileuser/updateUserInfo.do'
// 收藏病例URL
const COLLECTIONCASE_URL = 'mobileuser/getCollectionCaseList.do'
// 查询用户消息中心列表
const LIST_NEWS_BY_USERID = 'mobileusernotices/listnewsbyuserid.do'
// 查询用户未读消息个数
const QUERY_UNREAD_NUM = 'mobileusernotices/queryunreadnum.do'
// 消息中心一键已读
const MARK_ALL_AS_READ = 'mobileusernotices/markallasread.do'
// 消息中心标记已读
const MARK_AS_READ = 'mobileusernotices/markasread.do'
// 消息中心标记删除
const MARK_DEL_BY_ID = 'mobileusernotices/markdelbyid.do'
// 消息中心一键删除
const MARK_ALL_DEL = 'mobileusernotices/markalldel.do'
// 微信绑定URL
const WECHAT_BINDING = 'mobileuser/bindWx.do'
// 获取字典表数据URL
const GET_DIC_INFO_URL = 'dic/getDicInfo.do'
// 获取系统中所有的医院、id
const GET_ALL_HOSPITAL_NAME_ID = 'hospital/getAllHospital.do'
// 判断用户名是否存在
const IS_EXIST_USERNAME_URL = 'user/hasU.do'
// 医生资格证、电子签名上传地址
const UPLOAD_DOCTOR_INFO_PIC_URL = '/pms/user/uploadDocPic.do'
// 提交医生审核资料
const SUBMIT_DOCTOR_INFO_URL = 'doctorinfo/fastRegisterDoc.do'
// 获取样本列表
const GET_SAMPLE_LIST_URL = 'mobilecaseinfo/getSampleList.do'
// 获取玻片列表
const GET_SLIDE_LIST_URL = 'mobilecaseinfo/getSlideList.do'
// 获取病例细胞的信息
const GET_CELL_LIST_URL = 'assign/getCellList.do'
/* ************************************ 操作的URL地址 end ****************************** */






// WEBPACK FOOTER //
// ./src/utils/PmsConst.js